// import { ReturnToLink } from 'components/ReturnToLink';

import RequestDetails from '../../components/Requests/RequestDetails';

const RequestDetailsPage = () => {
  return (
    <div className="flex-1 py-5 sm:py-10">
      {/* <ReturnToLink to="/requests" title="View all requests" /> */}
      <RequestDetails />
    </div>
  );
};

export default RequestDetailsPage;
